import { useNavigate, useParams } from 'react-router'
import { useSnackbar } from '@tecsinapse/cortex-react'
import { EventGoal, EventOrigin, logEvent } from '@web/analytics'
import { AnalyticsEvents } from '@repo/types/src/enums/AnalyticsEvents'
import { PLATFORM } from '@repo/core'
import { ComponentOrderMessageVO } from '@repo/types/src/types/ComponentOrderMessageVO'
import { useSendOrderMessage } from '../../../../../../packages/core/src/send-order-message'

export const useSendOrderMessageWeb = () => {
  const navigate = useNavigate()
  const { snackbar } = useSnackbar()
  const { chatId } = useParams()
  const { handleSubmit, isSubmitting } = useSendOrderMessage()

  const handleClose = () => {
    navigate(-1)
  }

  const handleSendOrderMessage = (orderMessage: ComponentOrderMessageVO) => {
    handleSubmit(orderMessage, {
      onSuccess: () => {
        handleClose()
        logEvent({
          name: AnalyticsEvents.ENVIAR_COBRANCA,
          params: {
            origin: EventOrigin.button,
            goal: EventGoal.submit,
            platform: PLATFORM.WEB,
            connectionKey: orderMessage.connectionKey
          }
        })
      },
      onError: () =>
        snackbar.show('error', 'A operação não pôde ser concluída.\nAguarde alguns minutos e tente novamente.')
    })
  }

  return {
    chatId,
    handleSendOrderMessage,
    handleClose,
    isSubmitting
  }
}
